export default __webpack_public_path__ + "static/media/Unit_Citation.2759361c.jpg";